import { Guid } from "@/Common/Models/Guid";
import { Patient } from "@/Common/Models/Patient/Patient";
import { PopulationBasedFundingEventWithNotesModel } from "@/Common/Models/PopulationBasedFunding/PopulationBasedFundingEventWithNotesModel";
import { SiteUIModel } from "@/Common/Models/Sites/SiteUIModel";
import { EmployeeUIModel } from "@/Common/Models/UI/Employee/EmployeeUIModel";
import { PopulationBasedFundingPortfolioSortOrder, SortDirection } from "@/Common/Models/UI/Enums";
import { PopulationBasedFundingPortfolioFilterSettings } from "../Settings/PopulationBasedFundingTableFilterSettings";
import { PopulationBasedFundingEventTask } from "./PopulationBasedFundingEventTask";
import { PopulationBasedFundingPortfolioEvent } from "./PopulationBasedFundingPortfolioEvent";
import { PopulationBasedFundingStatusUIModel } from "./PopulationBasedFundingStatusUIModel";

class PopulationBasedFundingPortfolioModel {
    public IsMassAcceptDisabled: boolean = false;
    public FilterSettings: PopulationBasedFundingPortfolioFilterSettings = new PopulationBasedFundingPortfolioFilterSettings();
    public QueryOrderType: PopulationBasedFundingPortfolioSortOrder = PopulationBasedFundingPortfolioSortOrder.Patient;
    public QueryOrderDirection: SortDirection = SortDirection.ASC;

    public Data: PopulationBasedFundingPortfolioEvent[] = [];
    public SelectedEventIds: (Guid | string)[] = [];

    public AvailableSites: SiteUIModel[] = [];
    public AvailableClinicians: EmployeeUIModel[] = [];
    public AvailableStatus: PopulationBasedFundingStatusUIModel[] = [];

    public NewPatientToRegister: Patient = null;
    public EventToOverride: PopulationBasedFundingEventWithNotesModel = null;
    public InternalProposalToCompleteEventId: string = null;

    public TasksByEventIdDictionnary: { [eventId: string]: PopulationBasedFundingEventTask[] } = {};
    public ClickedEventTasksCounter: PopulationBasedFundingPortfolioEvent = null;
    public ClickedTasksCounterPosition: { x: number, y: number };
}

export { PopulationBasedFundingPortfolioModel };
